module.exports = __webpack_public_path__ + "static/media/arrow-left-blue.00001864.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/arrow-left-blue.svg
// module id = 116
// module chunks = 0